import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileDown, Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Download the case "Estrategia de victoria" report as PDF or Word
export const StrategyReportButtons = ({ matterId, title, testid = 'strategy-report' }) => {
  const { api } = useAuth();
  const [busy, setBusy] = useState(null);
  const get = async (format) => {
    setBusy(format);
    try {
      const r = await api.get(`/crm/matters/${matterId}/strategy-report`, { params: { format }, responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `estrategia-${(title || 'caso').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Za-z0-9]+/g, '-').slice(0, 60)}.${format}`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1500);
    } catch { toast.error('No se pudo descargar el informe'); } finally { setBusy(null); }
  };
  return (
    <div className="flex flex-wrap gap-2">
      {[['pdf', 'PDF'], ['docx', 'Word']].map(([f, l]) => (
        <button key={f} type="button" data-testid={`${testid}-${f}`} onClick={() => get(f)} disabled={!!busy}
          className="flex items-center gap-1 rounded-full border border-amber-500/50 px-3 py-1 text-xs text-amber-200 hover:bg-amber-500/10 disabled:opacity-50">
          {busy === f ? <Loader2 className="h-3 w-3 animate-spin" /> : <FileDown className="h-3 w-3" />}Estrategia de victoria ({l})
        </button>
      ))}
    </div>
  );
};
